import { dynamic } from '#/utils/dynamic';

export const userDashboardModalComponentByType = {
  INFORMATION_REQUIRED: dynamic(
    () =>
      import('./InformationRequired/InformationRequiredModalContainer').then(
        (module) => ({ default: module.InformationRequiredModalContainer }),
      ),
    { strategy: 'always' },
  ),
  NOTIFICATION_PREFERENCES: dynamic(
    () =>
      import('./NotificationPreferences/NotificationPreferencesModalContainer').then(
        (module) => ({ default: module.NotificationPreferencesModalContainer }),
      ),
    { strategy: 'always' },
  ),
  DELETE_ACCOUNT: dynamic(
    () =>
      import('./DeleteAccount/DeleteAccountModalContainer').then((module) => ({
        default: module.DeleteAccountModalContainer,
      })),
    { strategy: 'always' },
  ),
  ADD_EDIT_WORK_HISTORY_JOB: dynamic(
    () =>
      import('./AddEditWorkHistoryJob/AddEditWorkHistoryJobModalContainer').then(
        (module) => ({ default: module.AddEditWorkHistoryJobModalContainer }),
      ),
    { strategy: 'always' },
  ),
  ADD_EDIT_EDUCATION_HISTORY: dynamic(
    () =>
      import('./AddEditEducationHistory/AddEditEducationHistoryModalContainer').then(
        (module) => ({ default: module.AddEditEducationHistoryModalContainer }),
      ),
    { strategy: 'always' },
  ),
  DELETE_WORK_HISTORY_JOB: dynamic(
    () =>
      import('./DeleteWorkHistoryJob/DeleteWorkHistoryJobModalContainer').then(
        (module) => ({ default: module.DeleteWorkHistoryJobModalContainer }),
      ),
    { strategy: 'always' },
  ),
  DELETE_EDUCATION_HISTORY: dynamic(
    () =>
      import('./DeleteEducationHistory/DeleteEducationHistoryModalContainer').then(
        (module) => ({ default: module.DeleteEducationHistoryModalContainer }),
      ),
    { strategy: 'always' },
  ),
  INTAKE_INTENTS: dynamic(
    () =>
      import('./IntakeIntents/UserDashboardIntakeIntentsModal').then(
        (module) => ({ default: module.UserDashboardIntakeIntentsModal }),
      ),
    { strategy: 'always' },
  ),
  CURATE_SEARCH: dynamic(
    () =>
      import('#/modules/userDashboard/curateSearch/container/UserDashboardCurateSearchModalContainer').then(
        (module) => ({
          default: module.UserDashboardCurateSearchModalContainer,
        }),
      ),
    { strategy: 'always' },
  ),
  RESUME_RECOMMENDER_ONBOARDING: dynamic(
    () =>
      import('#/modules/userDashboard/resumeRecommender/ResumeRecommenderModal').then(
        (module) => ({ default: module.ResumeRecommenderModal }),
      ),
    { strategy: 'always' },
  ),
  PROFILE_WIZARD: dynamic(
    () =>
      import('#/modules/userDashboard/profile/containers/modals/Wizard/UserDashboardProfileWizardModalContainer').then(
        (module) => ({
          default: module.UserDashboardProfileWizardModalContainer,
        }),
      ),
    { strategy: 'always' },
  ),
  EDIT_SAVED_SEARCH: dynamic(
    () =>
      import('./EditSavedSearch/EditSavedSearchModalContainer').then(
        (module) => ({ default: module.EditSavedSearchModalContainer }),
      ),
    { strategy: 'always' },
  ),
  FIND_ORG: dynamic(
    () =>
      import('./FindOrganization/FindOrganizationModal').then((module) => ({
        default: module.FindOrganizationModal,
      })),
    { strategy: 'always' },
  ),
} as const satisfies Record<string, unknown>;
